export const CLASS_PREFIX = 'admin-portal'
